export const SELECTED_SUBSCRIPTION_STORAGE_KEY = 'tnest.apim.subscription.selection.v1';
export const LEGACY_SELECTED_SUBSCRIPTION_STORAGE_KEY = 'apim.selectedSubscription';
export const SUBSCRIPTION_ACCOUNT_ID_STORAGE_KEY = 'tnest.apim.subscription.accountId.v1';
export const SUBSCRIPTION_SELECTED_EVENT = 'tnest-subscription-selected';

export function extractSubscriptionAccountId(nameOrLabel) {
  if (!nameOrLabel) {
    return '';
  }
  const match = String(nameOrLabel).trim().match(/^(\d{4,})/);
  return match ? match[1] : '';
}
